<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="課程管理"
      fkey="tm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="filterChanged"
    ></populate-form>
    <div class="wrapper2" ref="wrapper" @scroll="handleScroll">
      <b-table ref="scrollarea" class="" stacked="sm" striped hover :items="items" :fields="fields" @scrolldownend="loadTickets(true)">
        <template v-slot:cell(actions)="row">
          <!--<b-button v-if="row.item.store_names===''" disabled size="sm" class="mr-1">
            分店未連結
          </b-button>-->
          <b-button size="sm" class="mr-1" @click.stop="pickStorePopup(row, row.index, $event.target)">
            {{row.item.store_names===''?'(未設定)':''}}設定分店
          </b-button>
          <b-button size="sm" @click.stop="editPopup(row, row.index, $event.target)" class="mr-1">
            {{row.item.ticket_project_confirmed?"修改設定":"新設定"}}
          </b-button>
          <b-button :disabled="row.item.store_names==''||!row.item.ticket_project_confirmed" size="sm" @click.stop="setupNW(row, row.index, $event.target)" class="mr-1">
            {{row.item.productsno>0?"檢視藍新設定":"建立藍新設定"}}
          </b-button>
        </template>
      </b-table>
    </div>
    <b-modal
      id="editTicketModal"
      ref="ticketModal"
      v-model="modalShow" 
      centered
      hide-header
      hide-footer
      :static="true"
      @hide="closeCheck"
      @shown="setFocus"
    >
      <populate-form
        formTitle="課程設定"
        fkey="ts01"
        ref="editForm"
        populateOptionVar="editOptions"
        :parentVue="this"
        formDataObjVar="formData"
      />
    </b-modal>
    <b-modal
      id="editApplyStoresModal"
      ref="storesModal"
      size="xl"
      v-model="storeModalShow" 
      centered
      :title="store_pick_class_name"
      hide-footer
      :static="true"
      @hide="closeCheckPick"
    >
      <div v-show="storeModalMode=='list'">
        <populate-form
          collapseStyle="simple"
          formTitle="添加店家"
          fkey="ds01"
          ref="selectForm"
          populateOptionVar="storePickOptions"
          :parentVue="this"
          formDataObjVar="storePickData"
          @customValueChanged="storeSearchChanged"
        />
        <div v-show="storePickingList.length > 0 && $refs.selectForm && $refs.selectForm.showFilter" class="wrapper3" ref="wrapper3" @scroll="handleScroll3">
          <b-table ref="pickarea" class="" stacked="sm" show-empty striped hover :items="storePickingList" :fields="picking_fields" @scrolldownend3="searchStoreCandidate(true)">
            <template v-slot:cell(actions)="row">
              <b-form-checkbox class="mx-auto" v-model="row.item.checked" @change="calSelected"/>
            </template>
          </b-table>
        </div>
        <div v-show="storePickingList.length==0 && $refs.selectForm && $refs.selectForm.showFilter" class="p-3 border">
          <p>請搜尋出待加入服務店家後再勾選添加</p>
        </div>
        <b-table :key="apply_stores_key" ref="appliedarea" class="mt-1" stacked="sm" show-empty striped hover :items="relStoreList" :fields="applied_store_fields">
          <template slot="empty">
            此課程尚未設定任何服務可核銷店家
          </template>
          <!--有改到店家於此課程例外顯示設定者,供應商名稱前面顯示全形的＊-->
          <template v-slot:cell(merchant_name)="row">
            {{has_custom(row.item)?'＊':''}}{{row.item.merchant_name}}
          </template>
          <template v-slot:cell(actions)="row">
            <b-button class="mr-1" @click="overrideStore(row, row.index)">別名</b-button>
            <b-button @click="cancelStore(row, row.index)">解除</b-button>
          </template>
        </b-table>
      </div>
      <div v-show="storeModalMode=='override_detail'">
        <!--再放一個自訂populate form表單吧-->
        <populate-form
          formTitle="自訂店家服務顯示設定"
          fkey="osd01"
          ref="overrideForm"
          populateOptionVar="overrideOptions"
          :parentVue="this"
          formDataObjVar="overrideData"
        />
      </div>
      <div style="text-align:left;" v-show="storeModalMode=='preview_store_service'">
        <div style="text-align:center;">預設此課程此店家服務資訊區塊顯示為：</div>
        <br>
        <h4>【{{overrideData.store_alias_name?overrideData.store_alias_name:overrideData.store_name}}】</h4>
        <p v-if="(overrideData.override_header_custom_note?overrideData.override_header_custom_note:overrideData.header_custom_note)!=''">{{overrideData.override_header_custom_note?overrideData.override_header_custom_note:overrideData.header_custom_note}}</p>
        <p >{{overrideData.override_store_contact_info?overrideData.override_store_contact_info:overrideData.store_contact_info}}</p>
        <p v-if="(overrideData.override_store_contact_info2?overrideData.override_store_contact_info2:overrideData.store_contact_info2)!=''">{{overrideData.override_store_contact_info2?overrideData.override_store_contact_info2:overrideData.store_contact_info2}}</p>
        <p >{{overrideData.store_address}}<span v-if="overrideData.loc_desc">({{overrideData.loc_desc}})</span></p>
        <p v-if="(overrideData.override_business_time?overrideData.override_business_time:overrideData.business_time)!=''">{{overrideData.override_business_time?overrideData.override_business_time:overrideData.business_time}}</p>
        <p v-if="(overrideData.override_holiday?overrideData.override_holiday:overrideData.holiday)!=''">{{overrideData.override_holiday?overrideData.override_holiday:overrideData.holiday}}</p>
        <p v-if="(overrideData.override_footer_custom_note?overrideData.override_footer_custom_note:overrideData.footer_custom_note)!=''">{{overrideData.override_footer_custom_note?overrideData.override_footer_custom_note:overrideData.footer_custom_note}}</p>
        <br>
        <br>
        <b-button style="margin-left:40%;" @click="storeModalMode='override_detail'" >返回</b-button>
      </div>
    </b-modal>
    <b-modal
      id="editApplyStoresModal"
      ref="storesModal"
      size="xl"
      v-model="classModalShow" 
      centered
      :title="nw_op_class_name"
      hide-footer
      :static="true"
      @hide="closeCheckClass"
    >
      <!--檢視模式不要用populate form喔,因為...目前form沒支援v-html的control component type,然後exchangeevent目前是含BR的字串-->
      <div v-if="nw_op_data && nw_op_data.productsno > 0" style="text-align:left; border-bottom-width:1px;border-bottom-style:inset;" >
        <div style="border-bottom-width:1px;border-bottom-style:inset;">商品名稱：{{nw_op_data.ez_print_json.productname}}{{nw_op_data.ez_print_json.productnumber}}</div>
        <div style="border-bottom-width:1px;border-bottom-style:inset;">商品內容：<span v-html="nw_op_data.ez_print_json.remark1" ></span></div>
        <div style="border-bottom-width:1px;border-bottom-style:inset;">注意事項：<div v-html="nw_op_data.ez_print_json.remark2" ></div></div>
        <div style="border-bottom-width:1px;border-bottom-style:inset;">價格：{{nw_op_data.ez_print_json.trustamount}}</div>
        <div style="border-bottom-width:1px;border-bottom-style:inset;">優惠期間：{{nw_op_data.ez_print_json.preferentialmaturity}}</div>
        <div style="border-bottom-width:1px;border-bottom-style:inset;" v-if="Array.isArray(nw_op_data.ez_print_json.exchangeevent)&&nw_op_data.ez_print_json.exchangeevent.length==0">業者(舊)：<br/>
          發行業者：{{nw_op_data.ez_print_json.issuer}}<BR/>
          統一編號：{{nw_op_data.ez_print_json.issuerudnumber}}<BR/>
          負責人：{{nw_op_data.ez_print_json.personincharge}}<BR/>
          登記地址：{{nw_op_data.ez_print_json.rgaddress}}<BR/>
        </div>
        <div style="border-bottom-width:1px;border-bottom-style:inset;" v-if="!Array.isArray(nw_op_data.ez_print_json.exchangeevent)">業者(新)：<br/>
          <div v-html="nw_op_data.ez_print_json.exchangeevent"></div>
        </div>
        <div>
          <button class="mr-3" @click="classModalShow=false">關閉</button>
          <button @click="syncNwProduct">同步</button>
        </div>
      </div>
      <div v-if="nw_op_data && !nw_op_data.productsno">
        <button @click="syncNwProduct">嘗試抓用product_id抓藍新已建立資料(大約等10秒)</button>
        <populate-form
          formTitle="藍新課程設定"
          fkey="nwc01"
          ref="newSetForm"
          populateOptionVar="newSetOptions"
          :parentVue="this"
          formDataObjVar="newSetData"
        />
        <b-button @click="previewTicketOk">預覽票券內容</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {
  apiGetTicketProjectList,
  apiGetMerchantAutoComplete,
  apiSearchStoreList,
  apiSetupProdStoreRel,
  apiSetupMerchantTicket,
  apiCreateNWProduct,
  apiUpdateNWProduct,
  apiForceSyncNow
} from '@/api/AdminManage.js'

export default {
  name: 'TicketManage',
  components: {
  
  },
  data: function () {
    return {
      // previewModalShow:false,
      classModalShow:false,
      nw_op_class_name:'',
      nw_op_data:{},
      //新增需要的變數格式和藍新回傳的ez_print_json不同,不要共用
      newSetData:{},
      newSetOptions:[
        {
          componentType:"span",
          placeholder:"課程名稱",
          col:2,
        },
        {
          componentType:"text",
          akey:'product_name',
          placeholder:"課程名稱",
          col:10,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"課程內容",
          col:2,
        },
        {
          componentType:"text",
          akey:'remark1',
          placeholder:"課程內容(NS沒有欄位可以帶請自己維護Q_Q)",
          col:10
        },
        {
          componentType:"span",
          placeholder:"售價",
          col:2,
        },
        {
          componentType:"text",
          akey:'sale_price',
          placeholder:"",
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"優惠期限",
          col:2,
        },
        {
          componentType:"text",
          akey:'expire_date',
          placeholder:"格式西元年的yyyymmdd",
          col:4,
          disabled:true
        },
        {
          componentType:"b-form-textarea",
          akey:'remark2',
          placeholder:"注意事項",
          title:"注意事項",
          rows:5,
          col:12
        },
        {
          componentType:"span",
          placeholder:"服務提供者",
          col:2,
        },
        {
          componentType:"text",
          akey:'merchant_name',
          placeholder:"",
          col:4
        },
        {
          componentType:"span",
          placeholder:"負責人",
          col:2,
        },
        {
          componentType:"text",
          akey:'person_in_charge',
          placeholder:"請key廠商負責人",
          col:4
        },
        {
          componentType:"span",
          placeholder:"供應商地址",
          col:2,
        },
        {
          componentType:"text",
          akey:'supplier_address',
          placeholder:"",
          col:10
        },
        {
          componentType:"btn-group",
          akey:'setnwbtns',
          col:12,
          buttons:[
            {
              akey:'cancel',
              col:3,
              placeholder:'取消',
              execCallback:()=>{this.classModalShow=false}
            },
            {
              akey:'create',
              col:3,
              placeholder:'確認建立',
              execCallback:this.createNWProduct
            },
            // {
            //   akey:'preview',
            //   col:3,
            //   placeholder:'預覽內容',
            //   execCallback:this.previewModalShow
            // }
          ]
        }
      ],
      storeModalShow:false,
      //storeModalMode預設為list,當查看/自訂某一個店家的設定值時,切換為override_detail
      storeModalMode:'list',
      overrideData:{},
      overrideIndex:0,
      overrideOptions:[
        {
          componentType:"span",
          akey:'merchant_name',
          placeholder:"供應商名稱",
          col:6,
          disabled:true
        },
        {
          componentType:"span",
          akey:'store_name',
          placeholder:"店家名稱",
          col:6,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"店名例外顯示",
          col:4,
          disabled:true
        },
        {
          componentType:"text",
          akey:"store_alias_name",
          placeholder:"有輸入則此課程內顯示的店名以此值取代",
          col:8,
        },
        {
          componentType:"span",
          placeholder:"店家備註1:",
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          akey:"header_custom_note",
          col:8,
        },
        {
          componentType:"text",
          akey:"override_header_custom_note",
          placeholder:"店家備註1例外",
          col:12,
        },
        {
          componentType:"span",
          placeholder:"聯絡電話:",
          col:2,
        },
        {
          componentType:"span",
          akey:"store_contact_info",
          col:4,
        },
        {
          componentType:"span",
          placeholder:"電話2:",
          col:2,
        },
        {
          componentType:"span",
          akey:"store_contact_info2",
          col:4,
        },
        {
          componentType:"text",
          akey:"override_store_contact_info",
          placeholder:"聯絡電話例外",
          col:6,
        },
        {
          componentType:"text",
          akey:"override_store_contact_info2",
          placeholder:"電話2例外",
          col:6,
        },
                {
          componentType:"span",
          placeholder:"營業時間:",
          col:2,
        },
        {
          componentType:"span",
          akey:"business_time",
          col:4,
        },
        {
          componentType:"span",
          placeholder:"公休日:",
          col:2,
        },
        {
          componentType:"span",
          akey:"holiday",
          col:4,
        },
        {
          componentType:"text",
          akey:"override_business_time",
          placeholder:"營業時間例外",
          col:6,
        },
        {
          componentType:"text",
          akey:"override_holiday",
          placeholder:"公休日例外",
          col:6,
        },
        {
          componentType:"span",
          placeholder:"店家備註2",
          col:4,
          disabled:true
        },
        {
          componentType:"span",
          akey:"footer_custom_note",
          col:8,
        },
        {
          componentType:"text",
          akey:"override_footer_custom_note",
          placeholder:"店家備註2例外",
          col:12,
        },
        {
          componentType:"b-button",
          placeholder:"取消返回",
          col:4,
          execCallback:()=>{this.storeModalMode='list'}
        },
        {
          componentType:"b-button",
          placeholder:"預覽一下",
          col:4,
          execCallback:this.previewStore
        },
        {
          componentType:"b-button",
          placeholder:"確認更新",
          col:4,
          execCallback:this.saveOneOverride
        },
      ],
      storePickData:{},
      popup_ticket_project_id:0,
      store_pick_class_name:'',
      //搜尋出來待勾選的店家列表
      storePickingList:[],
      pickPageNumber:0,
      pickItemsPerPage:50,
      pickSelected:0,
      pickHasMore:true,
      picking_fields:[
        {
          key: 'actions',
          label: '選取'
        },
        {
          key: 'merchant_name',
          label: '供應商',
          sortable: false
        },
        {
          key: 'store_name',
          label: '店家名稱',
          sortable: false
        },
        {
          key: 'store_address',
          label: '店家地址',
          sortable: false
        },
        {
          key: 'store_contact_info',
          label: '店家聯絡',
          sortable: false
        },
        
      ],
      applied_store_fields:[
        {
          key: 'merchant_name',
          label: '供應商',
          sortable: false
        },
        {
          key: 'store_name',
          label: '店家名稱',
          sortable: false
        },
        {
          key: 'store_address',
          label: '店家地址',
          sortable: false
        },
        {
          key: 'actions',
          label: '操作'
        },
      ],
      //每次打開popup時,從選取的item的課程的當下applyStores assign進來
      relStoreList:[],
      storePickOptions:[
        {
          componentType:'vue-single-select',
          optionVar:'Merchants',
          asyncFetchCB: this.loadMerchantByKeyword,
          defaultValue:null,
          akey:'selectedMerchant',
          optionLabel:'merchant_full_name',
          col:4,
          placeholder:'供應商',
        },
        {
          componentType:'b-form-select',
          defaultValue:'',
          akey:'addr_city',
          //這樣不好,但用變數的optionVar綁定方式預設值就帶不出來,得另外設法解決
          dataOptions:[{text:"篩選店家縣市",value:""},{text:"臺北市",value:"臺北市"},{text:"新北市",value:"新北市"},{text:"基隆市",value:"基隆市"},{text:"宜蘭縣",value:"宜蘭縣"},{text:"新竹市",value:"新竹市"},{text:"新竹縣",value:"新竹縣"},{text:"桃園市",value:"桃園市"},{text:"苗栗縣",value:"苗栗縣"},{text:"臺中市",value:"臺中市"},{text:"彰化縣",value:"彰化縣"},{text:"南投縣",value:"南投縣"},{text:"嘉義市",value:"嘉義市"},{text:"嘉義縣",value:"嘉義縣"},{text:"雲林縣",value:"雲林縣"},{text:"臺南市",value:"臺南市"},{text:"高雄市",value:"高雄市"},{text:"屏東縣",value:"屏東縣"},{text:"臺東縣",value:"臺東縣"},{text:"花蓮縣",value:"花蓮縣"},{text:"金門縣",value:"金門縣"},{text:"連江縣",value:"連江縣"},{text:"澎湖縣",value:"澎湖縣"}],
          col:4,
          title:"店家地址有分四段維護才能用來查詢"
        },
        {
          componentType:"text",
          akey:'addr_area',
          placeholder:"鄉鎮",
          col:4,
          execCallback:this.searchStoreCandidate,
          title:"店家地址有分四段維護才能用來查詢"
        },
        {
          componentType:"text",
          akey:'store_name',
          placeholder:"店家名稱",
          col:4,
          execCallback:this.searchStoreCandidate
        },
        {
          componentType:"text",
          akey:'keyword',
          placeholder:"關鍵字(供應商名+店名)",
          col:4,
          execCallback:this.searchStoreCandidate
        },
        {
          componentType:'btn-group',
          akey:'storeSearchBtnGroup',
          col:4,
          buttons:[
            {
              componentType:"b-button",
              akey:'btnSearch',
              placeholder:"查詢",
              col:3,
              execCallback:this.searchStoreCandidate
            },
            {
              componentType:"b-button",
              akey:'btnAdd',
              placeholder:"添加",
              col:3,
              execCallback:this.addToRel
            }
          ]
        }
      ],
      isLoading:false,
      formData: {},
      editOptions: [
        {
          componentType:"span",
          placeholder:"PI",
          col:4
        },
        {
          componentType:"text",
          akey:'product_id',
          placeholder:"",
          col:6,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"NI",
          col:4
        },
        {
          componentType:"text",
          akey:'ns_item_id',
          placeholder:"",
          col:6,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"類型",
          title:"pure_paper:純紙本\ndual_reserve:紙電共存\nelectronic:電子票\npaper_non_reserve:紙本可核銷",
          col:4
        },
        {
          componentType:"text",
          akey:'prod_cond',
          placeholder:"",
          col:6,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"供應商",
          col:4
        },
        {
          componentType:"text",
          akey:'merchant_name',
          placeholder:"",
          col:6,
          disabled:true
        },
        /*{
          componentType:"span",
          placeholder:"對應分店",
          col:4
        },
        {
          componentType:"b-form-textarea",
          akey:'store_names',
          placeholder:"",
          col:6,
          rows:3,
          disabled:true
        },*/
        {
          componentType:"span",
          placeholder:"信託價/成本",
          col:4
        },
        {
          componentType:"text",
          akey:'sale_price',
          placeholder:"",
          col:3,
          disabled:true
        },
        {
          componentType:"text",
          akey:'cost_price',
          placeholder:"",
          col:3,
          disabled:true
        },
        {
          componentType:"span",
          placeholder:"",
          col:2
        },
        {
          componentType:"span",
          placeholder:"課程服務時間",
          col:4
        },
        {
          componentType:"number",
          akey:'service_standard_minutes',
          placeholder:"輸入服務時間(尚未支援分開維護)",
          col:4,
        },
        {
          componentType:"span",
          placeholder:"",
          col:4
        },
        {
          componentType:"span",
          placeholder:"優惠生效日",
          col:4
        },
        {
          componentType:"date-picker",
          akey:'project_start_date',
          placeholder:"輸入優惠生效日",
          col:6,
        },
        {
          componentType:"span",
          placeholder:"",
          col:2
        },
        {
          componentType:"span",
          placeholder:"優惠結束日",
          col:4
        },
        {
          componentType:"date-picker",
          akey:'project_end_date',
          placeholder:"輸入優惠結束日",
          col:6,
        },
        {
          componentType:"span",
          placeholder:"",
          col:2
        },
        {
          componentType:"span",
          placeholder:"延長結束日",
          col:4
        },
        {
          componentType:"date-picker",
          akey:'project_extend_date',
          placeholder:"輸入優惠延長結束日",
          col:6,
        },
        {
          componentType:"span",
          placeholder:"",
          col:2
        },
        {
          componentType:"span",
          placeholder:"建議售價",
          col:4
        },
        {
          componentType:"number",
          akey:'suggest_price',
          placeholder:"建議售價",
          col:6,
        },
        {
          componentType:"span",
          placeholder:"",
          col:2
        },
        {
          componentType:"b-button",
          akey:'btnCancel',
          placeholder:"取消",
          col:6,
          execCallback:this.modalCancel
        },
        {
          componentType:"b-button",
          akey:'btnOK',
          placeholder:"保存",
          col:6,
          hide:(this.$bus.session&&['support','support_mgr'].includes(this.$bus.session.role_type)),
          execCallback:this.modalOK,
          waitClick:true,
        },
      ],
      filterData: {},
      filterOptions: [
        {
          componentType:'vue-single-select',
          optionVar:'Merchants',
          asyncFetchCB: this.loadMerchantByKeyword,
          defaultValue:null,
          akey:'SelectedMerchantItem',
          optionLabel:'merchant_full_name',
          col:9,
          placeholder:'選擇商家(輸入至少一個字的商家名稱關鍵字或SU編號帶出選項,按Esc可清除全部關鍵字)',
        },
        {
          componentType:'text',
          defaultValue:'',
          akey:'ticket_project_name',
          col:3,
          placeholder:'關鍵字查詢(名稱與PI)',
          execCallback:this.loadTickets,
        },
        {
          componentType:'date-picker',
          defaultValue:null,
          akey:'QueryStartDate',
          col:3,
          placeholder:'篩選優惠到期日起',
        },
        {
          componentType:'date-picker',
          defaultValue:null,
          akey:'QueryEndDate',
          col:3,
          placeholder:'篩選優惠到期日迄',
        },
        {
          componentType:'b-form-select',
          defaultValue:'all',
          akey:'Iconfirmed',
          dataOptions:[{text:'全部設定狀態',value:'all'},{text:'僅未設定',value:'pending'},{text:'僅已設定',value:'confirmed'}],
          col:2,
        },
        {
          componentType:'btn-group',
          col:4,
          buttons:[
            {
              componentType:'b-button',
              akey:'btnSync',
              col:3,
              placeholder:'同步',
              execCallback: this.forceSync
            },
            {
              componentType:'b-button',
              akey:'btnQry',
              col:3,
              placeholder:'查詢',
              execCallback: this.loadTickets
            },
          ]
        }
      ],
      isSyncRunning:false,
      showFilter: true,
      Merchants: [],
      SelectedMerchantId: null,
      SelectedMerchantItem: Object,
      SelectedMerchant: Object,
      QueryStartDate: null,
      QueryEndDate: null,
      modalShow: false,
      editingRow: {},
      editingIndex: 0,
      items: [],
      pageNumber:0,
      itemsPerPage:50,
      hasMore:true,
      fields: [
        {
          key: 'product_id',
          label: '票券序號',
          sortable: false
        },
        {
          key: 'ticket_project_name',
          label: '課程名稱',
          sortable: false
        },
        {
          key: 'service_items[0].service_standard_minutes',
          label: '課程長度',
          sortable: false
        },
        {
          key: 'sale_price',
          label: '售價',
          sortable: true
        },
        {
          key:'wait_use_count',
          label:'未用張數',
        },
        {
          key: 'actions',
          label: '功能'
        }
      ],
      apply_stores_key: 0,
    }
  },
  methods: {
    previewTicketOk(){
      // alert(JSON.stringify(this.newSetData));
      // alert(JSON.stringify(this.newSetData.remark2));
      let preview_remark2 = this.newSetData.remark2.replaceAll('\n','<br>');
      let product_name = this.newSetData.product_name;
      let remark1 = this.newSetData.remark1;
      let sale_price = this.newSetData.sale_price;
      let project_end_date = this.newSetData.project_end_date.replaceAll('-','');
      let merchant_name = this.newSetData.merchant_name;
      let supplier_address = this.newSetData.supplier_address;
      let person_in_charge = this.newSetData.person_in_charge;

      // alert(JSON.stringify(preview_remark));
      const h = this.$createElement;
      const titleVNode = h('p', {class: ['preview_title']}, [h('strong', '預覽票券內容(請用全螢幕校正)')]);
      const messageVNode = 
        h('div', {class: ['preview_container']}, [
          // 背景
          h('b-img', {
            props: {
              src: this.getImgUrl('paper_single.jpg'),
              thumbnail: true,
              center: true,
              fluid: true,
              alt: 'background',
            }
          }),
          // 總表 訂單編號 barcode
          h('p', {class: ['preview_general total_no']}, ['HHP2020120900001'] ),
          h('p', {class: ['preview_general order_no']}, ['0000099999000041 *'] ),
          // h('div', {class: ['preview_container']},
          h('b-img', {
            props: {
              src: this.getImgUrl('barcode1.png'),
              alt: 'barcode1',
            }, 
            class: 'preview_general barcode1'
          }),   
          // ),       
          // 名稱 內容 價格 優惠期間 注意事項
          h('p', {class: ['preview_general p_name']}, [product_name]),
          h('p', {class: ['preview_general p_remark1']}, [remark1]),
          h('p', {class: ['preview_general p_price']}, [sale_price]),
          h('p', {class: ['preview_general p_end_date']}, [project_end_date]),
          h('div', {class: ['preview_general preview_content']}, [
              h( 'div', { domProps: { innerHTML: preview_remark2 } }) 
          ]),
          // 服務商 電話 地址 負責人 barcode
          h('div', [
            h('p', {class: ['preview_general s_firm']}, [merchant_name]),
            h('p', {class: ['preview_general s_name']}, ['• 負責人：'+person_in_charge]),
            h('p', {class: ['preview_general s_address']}, [supplier_address]),
          ]),
          h('b-img',{
            props: {
              src: this.getImgUrl('barcode2.png'),
              alt: 'barcode2',
            },
            class: 'preview_general barcode2'
          }),           
          // 發行者 統一編號 負責人 登記地址 
          h('p', {class: ['preview_general ss_firm']}, ['耐德科技股份有限公司']),
          h('p', {class: ['preview_general ss_invoice']}, ['70549500']),
          h('p', {class: ['preview_general ss_name']}, ['陳昶任']),
          h('p', {class: ['preview_general ss_address']}, ['台北市中正區博愛路38號4樓']),
          // 信託銀行 發行日 有效期間 信託碼 qrcode
          h('p', {class: ['preview_general ss_bank']}, ['聯邦銀行']),
          h('p', {class: ['preview_general ss_date']}, ['66666666']),
          h('p', {class: ['preview_general ss_period']}, ['20200101-20201231']),
          h('p', {class: ['preview_general ss_num']}, ['888888888888888']),
          h('b-img',{
            props: {
              src: this.getImgUrl('qrcode1.png'),
              alt: 'qrcode1',
            },
            class: 'preview_general qrcode1'
          }),   
        ])
      this.$bvModal.msgBoxOk([messageVNode], {
        title: [titleVNode],
        buttonSize: 'xl',
        centered: true, size: 'xl'
      })
    },
    getImgUrl(code){
      // alert("../../assets/images/chroom_img/"+pic);
      if(code){
        return require(`../../assets/images/chroom_img/${code}`);
      }
      else {
        return
      }
    },
    previewStore() {
      this.storeModalMode = 'preview_store_service'
    },
    createNWProduct() {
      //用this.newSetData去呼叫api建立藍新課程
      let rptParam = {
        'module':'admin_manage',
        'method':'createNWProduct',
        'ticket_project_id': this.popup_ticket_project_id,
        enddate:this.newSetData.expire_date,
        //不填api會塞預設值,有需要再拉介面出來
        serviceemail:'',
        remark1:this.newSetData.remark1,
        remark2:this.newSetData.remark2,
        ticket_supplier_name:this.newSetData.merchant_name,
        ticket_supplier_boss_name:this.newSetData.person_in_charge,
        ticket_supplier_address:this.newSetData.supplier_address
      }

      this.isLoading = true
      let vm = this
      apiCreateNWProduct(rptParam).then(function(resp){
        let data = resp.data
        //這個還沒修好= =
        if (data.data.ez_print_json) {
          vm.items[vm.editingIndex].ez_print_json = JSON.parse(data.data.ez_print_json)
        }
        else {
           vm.items[vm.editingIndex].ez_print_json = data.data.ezPrintJson
        }
        //vm.storeModalShow = false
        vm.$bus.fnShowInfo('更新成功')
        if (data.data.ez_print_json) {
          vm.nw_op_data.ez_print_json = JSON.parse(data.data.ez_print_json)
        }
        else {
          vm.nw_op_data.ez_print_json = data.data.ezPrintJson
        }
        vm.nw_op_data.productsno = vm.nw_op_data.ez_print_json.productsno
        vm.isLoading = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          vm.isLoading = false
          return
        }
      })
      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   //這個還沒修好= =
      //   vm.items[vm.editingIndex].ez_print_json = JSON.parse(data.data.ez_print_json)
      //   vm.items[vm.editingIndex].productsno = data.data.productsno
      //   //vm.storeModalShow = false
      //   vm.$bus.fnShowInfo('建立成功')
      //   vm.nw_op_data.ez_print_json = JSON.parse(data.data.ez_print_json)
      //   vm.nw_op_data.productsno = vm.nw_op_data.ez_print_json.productsno
      //   vm.isLoading = false
      // }, this)
    },
    syncNwProduct() {
      let rptParam = {
        'module':'admin_manage',
        'method':'updateNWProduct',
        'ticket_project_id': this.popup_ticket_project_id
      }
      this.isLoading = true
      let vm = this
      apiUpdateNWProduct(rptParam).then(function(resp){
        let data = resp.data
        //這個還沒修好= =
        if (data.data.ez_print_json) {
          vm.items[vm.editingIndex].ez_print_json = JSON.parse(data.data.ez_print_json)
        }
        else {
           vm.items[vm.editingIndex].ez_print_json = data.data.ezPrintJson
        }
        //vm.storeModalShow = false
        vm.$bus.fnShowInfo('更新成功')
        if (data.data.ez_print_json) {
          vm.nw_op_data.ez_print_json = JSON.parse(data.data.ez_print_json)
        }
        else {
          vm.nw_op_data.ez_print_json = data.data.ezPrintJson
        }
        vm.nw_op_data.productsno = vm.nw_op_data.ez_print_json.productsno
        vm.isLoading = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          vm.isLoading = false
          return
        }
      })
      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   //這個還沒修好= =
      //   vm.items[vm.editingIndex].ez_print_json = JSON.parse(data.data.ez_print_json)
      //   //vm.storeModalShow = false
      //   vm.$bus.fnShowInfo('更新成功')
      //   vm.nw_op_data.ez_print_json = JSON.parse(data.data.ez_print_json)
      //   vm.nw_op_data.productsno = vm.nw_op_data.ez_print_json.productsno
      //   vm.isLoading = false
      // }, this)
    },
    buildRemark2(item) {
      console.log(item)
      //規則：因紙本票空間仍有限,預設顯示:
      //只有一家店時:
      //1.店名+電話
      //2.地址+接近
      //3.營業時間+公休日
      //4~7是固定的,限用+預約規則+出示票券+客服電話,其中限用可以帶原價參數進入
      //有2~4家配合店家時:
      //檢查別名後的營業時間和公休日,若諸店均相同,則預設帶入1.營業時間(公休日)
      //若各店不同則為 1.{供應商名}各店營業時間及公休日請電話洽詢
      //接下來每間店一行,店名+電話+地址
      //再後面接的四項和一家店時相同規則
      //有5家配合店家以上時：
      //1.和2~4家店時規則相同,只有剛好全部都統一時才直接顯示(大概率是固定寫死電話洽詢)
      //店家的部分,則是店名+電話+分號一路黏起來,整個一個段落就好,不每個店家換行一行
      //再後面接的四項和一家店時相同規則
      //先放變數與預設值
      let first_hint = "《"+item.merchant_name+"》各店營業時間及公休日請電話洽詢。\n"
      let store_desc = ""
      let usage_limit = "每人最多限用 "+item.usage_limit_per_user+" 張課程券，限女性使用(生理期及孕婦不適用)，1張課程券限同1人使用。逾期需補差額(原價"+item.suggest_price+"元)。\n"
      let reserve_rule = "請至少於預期來店一週前先行以電話預約。實際預約情形需依店家當天預約狀況為主，逾時15分鐘視同取消該次預約，敬請配合。恕不接受現場直接預約。\n"
      let show_rule = "請務必出示Shopping99兌換券，恕不接受未持兌換券者。\n"
      let contact_info = "buty99客服line@：@buty99。全國性消費者服務專線：1950"
      let other_rules = usage_limit+reserve_rule+show_rule+contact_info
      //店家的部分就要照規則組
      let tmp_overriden_store_contact_info = ''
      let tmp_overriden_store_contact_info2 = ''
      let tmp_overriden_business_time = ''
      let tmp_overriden_holiday = ''
      let prev_time_holiday = null
      let time_holiday_all_the_same = true
      
      if (item.apply_stores.length == 1) {
        //一家店會直接拉出店家的營業時間和公休日,不需要第一行
        first_hint = ''
        tmp_overriden_store_contact_info = item.apply_stores[0].override_store_contact_info?item.apply_stores[0].override_store_contact_info:item.apply_stores[0].store_contact_info
        tmp_overriden_store_contact_info2 = item.apply_stores[0].override_store_contact_info2?item.apply_stores[0].override_store_contact_info2:item.apply_stores[0].store_contact_info2
        //有聯絡電話2時,單店可以預設顯示
        store_desc += "【"+item.apply_stores[0].store_name+"】"+tmp_overriden_store_contact_info+(tmp_overriden_store_contact_info2?(';'+tmp_overriden_store_contact_info2):'')+"\n"
        store_desc += '地址：'+item.apply_stores[0].store_address+(item.apply_stores[0].loc_desc?('('+item.apply_stores[0].loc_desc+')'):'')+"\n"
        tmp_overriden_business_time = item.apply_stores[0].override_business_time?item.apply_stores[0].override_business_time:item.apply_stores[0].business_time
        tmp_overriden_holiday = item.apply_stores[0].override_holiday?item.apply_stores[0].override_holiday:item.apply_stores[0].holiday
        //必須有營業時間才帶得出休假日說明...就先這樣吧
        store_desc += tmp_overriden_business_time?(tmp_overriden_business_time+(tmp_overriden_holiday?(';'+tmp_overriden_holiday):'')+"\n"):''
      }
      else if (item.apply_stores.length <=4 ) {
        item.apply_stores.forEach(store => {
          tmp_overriden_store_contact_info = store.override_store_contact_info?store.override_store_contact_info:store.store_contact_info
          tmp_overriden_store_contact_info2 = store.override_store_contact_info2?store.override_store_contact_info2:store.store_contact_info2
          tmp_overriden_business_time = store.override_business_time?store.override_business_time:store.business_time
          tmp_overriden_holiday = store.override_holiday?store.override_holiday:store.holiday
          if (prev_time_holiday == null) {
            prev_time_holiday = tmp_overriden_business_time?(tmp_overriden_business_time+(tmp_overriden_holiday?('('+tmp_overriden_holiday+')'):'')+"\n"):''
          }
          else if (prev_time_holiday != (tmp_overriden_business_time?(tmp_overriden_business_time+(tmp_overriden_holiday?('('+tmp_overriden_holiday+')'):'')+"\n"):'')){
            time_holiday_all_the_same = false
          }
          //店多時地址的loc_desc就放棄了,電話2暫時保留
          store_desc += "【"+store.store_name+"】"+tmp_overriden_store_contact_info+(tmp_overriden_store_contact_info2?(';'+tmp_overriden_store_contact_info2):'')+' '+store.store_address+"\n"
        });
        if (time_holiday_all_the_same && prev_time_holiday != '') {
          first_hint = prev_time_holiday
        }
      }
      else if (item.apply_stores.length >=5 ) {
        item.apply_stores.forEach(store => {
          tmp_overriden_store_contact_info = store.override_store_contact_info?store.override_store_contact_info:store.store_contact_info
          //tmp_overriden_store_contact_info2 = store.override_store_contact_info2?store.override_store_contact_info2:store.store_contact_info2
          tmp_overriden_business_time = store.override_business_time?store.override_business_time:store.business_time
          tmp_overriden_holiday = store.override_holiday?store.override_holiday:store.holiday
          if (prev_time_holiday == null) {
            prev_time_holiday = tmp_overriden_business_time?(tmp_overriden_business_time+(tmp_overriden_holiday?('('+tmp_overriden_holiday+')'):'')+"\n"):''
          }
          else if (prev_time_holiday != (tmp_overriden_business_time?(tmp_overriden_business_time+(tmp_overriden_holiday?('('+tmp_overriden_holiday+')'):'')+"\n"):'')){
            time_holiday_all_the_same = false
          }
          //店太多時連地址都別放,避免讓紙本票的注意事項爆炸,只把最精簡的店名加電話放進去
          store_desc += (store_desc==''?'店家資訊:':'')+store.store_name+tmp_overriden_store_contact_info+';'
        });
        //迴圈跑完後,最後一間店後要換行
        store_desc += "\n"
        if (time_holiday_all_the_same && prev_time_holiday != '') {
          first_hint = prev_time_holiday
        }
      }
      //自動每個row前面補上流水號
      let lines_text = first_hint+store_desc+other_rules
      let lines = lines_text.split('\n')
      let result = ''
      let line_index = 0
      result = lines.reduce(function(tmp, line){
        line_index++
        return tmp+(tmp==''?'':"\n")+line_index+"."+line
      },"")
      return result
    },
    overrideStore(row, index) {
      //需要顯示自訂設定表單
      //當然是可以撐開row template啦,但很難用
      //讓店家勾選設定的popup modal支援兩種模式,編輯時用同一個modal吧
      this.overrideData = row.item
      this.overrideIndex = index
      this.$refs.overrideForm.refreshModelVar()
      this.storeModalMode = 'override_detail'
    },
    saveOneOverride() {
      //要update來源的relStoreList的那一筆的值,然後call api整個update掉(即時更新)
      //overrideData替換掉relStoreList對應那筆的資料,然後整個課程要reset
      this.relStoreList[this.overrideIndex] = this.overrideData
      let rptParam = {
        'module':'admin_manage',
        'method':'setupProdStoreRel',
        'ticket_project_id': this.popup_ticket_project_id,
        'apply_stores':JSON.stringify(this.relStoreList)
      }
      this.isLoading = true
      let vm = this
      apiSetupProdStoreRel(rptParam).then(function(resp){
        let data = resp.data
        //這個還沒修好= =
        vm.items[vm.editingIndex].apply_stores = data.data.apply_stores
        //vm.storeModalShow = false
        vm.$bus.fnShowInfo('更新成功')
        vm.storeModalMode = 'list'
        
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
      })
      vm.isLoading = false

      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   //這個還沒修好= =
      //   vm.items[vm.editingIndex].apply_stores = data.data.apply_stores
      //   //vm.storeModalShow = false
      //   vm.$bus.fnShowInfo('更新成功')
      //   vm.storeModalMode = 'list'
      //   vm.isLoading = false
      // }, this)
    },
    has_custom(item) {
      //item的任何override開頭的property值是非falsy就是有自訂修改覆蓋
      //store_alias_name不是override開頭要例外Q_Q
      return (item.store_alias_name !== '') || Object.keys(item).reduce(function(has_custom, attr) {
          return has_custom || (attr.startsWith('override') && item.attr );
      },false)
    },
    cancelStore(row, index) {
      //alert('要刪除'+JSON.stringify(row.item))
      //取消是confirm後立即生效
      let vm = this
      this.$bus.fnShowConfirm(('請確認是否取消此店家的服務核銷設定?'),() => {
        //call api
        //把這一筆從陣列裡移掉,然後再整個reset回去(目前api提供批次更新機制整組reset)
        //也可以設計刪除時先mark為待移除,上面提供確認按鈕才呼叫api更新並生效
        //這偏向批次勾選取消的模式...初期非必要先不開發,採可以一次勾很多個一口氣加入,但刪除要一個一個確認的方式操作就好
        //先移掉要刪的那項
        let item_deleted = this.relStoreList[index]
        // console.log("要刪除的",item_deleted);

        this.relStoreList.splice(index,1);
        let rptParam = {
          'module':'admin_manage',
          'method':'setupProdStoreRel',
          'ticket_project_id': this.popup_ticket_project_id,
          'apply_stores':JSON.stringify(this.relStoreList)
        }
        this.isLoading = true
        apiSetupProdStoreRel(rptParam).then(function(resp){
          console.log('ok!')
          vm.$bus.fnClosePopup()
          let data = resp.data
          //這個還沒修好= =
          vm.items[vm.editingIndex].apply_stores = data.data.apply_stores
          //vm.storeModalShow = false
          vm.$bus.fnShowInfo('更新成功')
          vm.storeModalMode = 'list'
          
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        })
        this.isLoading = false

        // this.$bus.apiCall(rptParam, function (data, vm) {
        //   if (data.ok === 0) {
        //     vm.$bus.fnClosePopup()
        //     vm.$bus.fnShowInfo(data.msg) 
        //     // 刪除的要加回
        //     vm.relStoreList.push(item_deleted);                                                                                           
        //     vm.isLoading = false
        //     return
        //   }
        //   else {
        //   //這個還沒修好= =
        //     vm.items[vm.editingIndex].apply_stores = data.data.apply_stores
        //     //vm.storeModalShow = false
        //     vm.$bus.fnClosePopup()
        //     vm.$bus.fnShowInfo('設定成功')
        //     vm.isLoading = false
        //   }
        // }, this)
        return
      }, () => {
        this.$bus.fnClosePopup()
        return 
      })

    },
    searchStoreCandidate(append = false, from_merchant_pick = false) {
      if (this.isLoading) {
        return
      }
      if (append === true) {
        if (!this.pickHasMore || this.isLoading) {
          return
        }
        this.pageNumber ++
      }
      else {
        this.pageNumber = 1
        this.pickHasMore = true
        this.$refs.wrapper3.scrollTop = 0
      }
      let rptParam = {
        'module':'admin_manage',
        'method':'searchStoreList',
        'merchant_id': this.storePickData.selectedMerchant?this.storePickData.selectedMerchant.merchant_id:0,
        'store_name':this.storePickData.store_name,
        'keyword':this.storePickData.keyword,
        'addr_city':this.storePickData.addr_city,
        'addr_area':this.storePickData.addr_area,
        'page_number':this.pickPageNumber,
        'items_per_page':this.pickItemsPerPage,
      }
      this.isLoading = true
      let vm = this
      apiSearchStoreList(rptParam).then(function(resp){
        let data = resp.data
        //data.data.store_list要和已加入的店家比較,原本就已選好的店家,直接splice掉不要再提供勾選
        data.data.store_list = vm.removeExisted(data.data.store_list, vm.relStoreList)
        if (vm.pageNumber === 1) {
          vm.storePickingList = data.data.store_list.filter(function(item){
            return item.is_open !== 0
          })
        }
        else {
          vm.storePickingList = vm.storePickingList.concat(data.data.store_list)
        }
        vm.pickHasMore = data.data.has_more
        vm.isLoading = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          vm.isLoading = false
          return
        }
      })
      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   //data.data.store_list要和已加入的店家比較,原本就已選好的店家,直接splice掉不要再提供勾選
      //   data.data.store_list = vm.removeExisted(data.data.store_list, vm.relStoreList)
      //   if (vm.pageNumber === 1) {
      //     vm.storePickingList = data.data.store_list
      //   }
      //   else {
      //     vm.storePickingList = vm.storePickingList.concat(data.data.store_list)
      //   }
      //   vm.pickHasMore = data.data.has_more
      //   vm.isLoading = false
      // }, this)
    },
    removeExisted(new_items, existed_items) {
      //兩次reduce還蠻噁心的,不過本質上確實適合這樣寫就是了
      //不要讓已在套用店家列表的店家,再出現在可以勾選加入套用的選單
      let existed_store_ids = existed_items.reduce(function (res, item) {
        return res.concat(item.merchant_store_id)
      },[])
      return new_items.reduce(function(result, store_item){
        return result.concat(existed_store_ids.includes(store_item.id)?[]:store_item)
      },[])
    },
    calSelected() {
      this.pickSelected = 0
      //剛click觸發時馬上迴圈計算會沒算到被點的自己勾選狀態的變化...
      setTimeout(() => {
        for (let i=0;i<this.storePickingList.length;i++) {
          if (this.storePickingList[i].checked) {
            this.pickSelected++
          }
        }
        if (this.pickSelected > 0) {
          this.$refs.selectForm.setDisabled('storeSearchBtnGroup.btnAdd', false)
        }
        else {
          this.$refs.selectForm.setDisabled('storeSearchBtnGroup.btnAdd', true)
        }
      }, 50);
    },
    addToRel() {
      // 這個稍微複雜一些,需要組出json再呼叫api設定進去
      // 傳的json參數需求是,原本已套用的 加上這次查詢後勾選的新增資料
      let newApplied = this.CpObj(this.relStoreList)
      let row_seq = newApplied.length
      let newSerStore = {}
      for (let i=0;i<this.storePickingList.length;i++) {
        if (this.storePickingList[i].checked) {
          row_seq++;
          newSerStore = {
            'merchant_store_id':this.storePickingList[i].id,
            'display_row_seq':row_seq,
            'store_alias_name':'',
            'override_last_reserve_time':null,
            'override_header_custom_note':'',
            'override_store_contact_info':'',
            'override_store_contact_info2':'',
            'override_business_time':'',
            'override_holiday':'',
            'override_footer_custom_note':'',
            //下面三個api不需要post出去是浪累,但,可以快速refresh頁面的列表,就浪費吧= =
            'store_name':this.storePickingList[i].store_name,
            'merchant_name':this.storePickingList[i].merchant_name,
            'store_address':this.storePickingList[i].store_address
          }
          newApplied.push(newSerStore)
        }
      }
      //然後準備呼叫api更新資料
      let rptParam = {
        'module':'admin_manage',
        'method':'setupProdStoreRel',
        'ticket_project_id': this.popup_ticket_project_id,
        'apply_stores':JSON.stringify(newApplied)
      }
      this.isLoading = true
      let vm = this
      apiSetupProdStoreRel(rptParam).then(function(resp){
        let data = resp.data
        //這個還沒修好= =
        // console.log('here', vm.editingIndex)
        // console.log('here2', vm.items[vm.editingIndex])
        vm.items[vm.editingIndex].apply_stores = JSON.parse(JSON.stringify(newApplied)) 
        vm.relStoreList = JSON.parse(JSON.stringify(vm.items[vm.editingIndex].apply_stores))
        //vm.storeModalShow = false
        vm.$bus.fnShowInfo('更新成功')
        vm.storeModalMode = 'list'
        
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
      })
      vm.isLoading = false

      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   //這個還沒修好= =
      //   vm.items[vm.editingIndex].apply_stores = data.data.apply_stores
      //   //vm.storeModalShow = false
      //   vm.$bus.fnShowInfo('設定成功')
      //   vm.relStoreList = newApplied
      //   vm.isLoading = false
      // }, this)

    },
    handleScroll3(evt) {
      // 僅偵測垂直scroll時是否scroll位置到達95%的位置,是則觸發事件(不能由div觸發需要被捲的組件觸發與偵測＝＝)
      //if ((evt.target.scrollTop/(evt.target.scrollHeight-evt.target.clientHeight)) > 0.95) {
      // 只能把計算邏輯抽到$bus而已,需要this.$refs.scrollarea這個沒辦法丟過去(若為此要把wrapper寫成獨立組件又太麻煩先這樣吧)
      if (this.calScrollRatio(evt) > 0.95) {
        this.$refs.pickarea.$emit('scrolldownend3')
      }
    },
    handleScroll(evt) {
      // 僅偵測垂直scroll時是否scroll位置到達95%的位置,是則觸發事件(不能由div觸發需要被捲的組件觸發與偵測＝＝)
      //if ((evt.target.scrollTop/(evt.target.scrollHeight-evt.target.clientHeight)) > 0.95) {
      // 只能把計算邏輯抽到$bus而已,需要this.$refs.scrollarea這個沒辦法丟過去(若為此要把wrapper寫成獨立組件又太麻煩先這樣吧)
      if (this.calScrollRatio(evt) > 0.95) {
        this.$refs.scrollarea.$emit('scrolldownend')
      }
    },
    filterChanged (upd) {
      if (upd.key === 'SelectedMerchantItem') {
        if (upd.val) {
          this.SelectedMerchantId = upd.val.merchant_id
        }
        else {
          this.SelectedMerchantId = null
        }
      }
      if (['SelectedMerchantItem','Iconfirmed'].includes(upd.key)) {
        setTimeout(() => {
          this.loadTickets()
        }, 50);
      }
    },
    storeSearchChanged(upd) {
      if (['selectedMerchant','addr_city'].includes(upd.key)) {
        //從有選定供應商變成未選取不要自動觸發列表重載
        if (['selectedMerchant'].includes(upd.key) && upd.val == null) {
          return
        }
        setTimeout(() => {
          this.searchStoreCandidate()
        }, 50);
      }
    },
    loadMerchantByKeyword (keyword) {
      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Merchants = []
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getMerchantAutoComplete',
        'keyword':keyword,
      }
      let vm = this
      apiGetMerchantAutoComplete(Param).then(function(resp){
        let data = resp.data
        vm.Merchants = data.data.matched_merchant_list
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     vm.Merchants = data.data.matched_merchant_list
      // },this)
    },
    loadTickets: function (append = false) {
      if (this.isLoading) {
        return
      }
      if (append === true) {
        if (!this.hasMore || this.isLoading) {
          return
        }
        this.pageNumber ++
      }
      else {
        this.pageNumber = 1
        this.hasMore = true
        this.$refs.wrapper.scrollTop = 0
      }
      let rptParam = {
        'module':'admin_manage',
        'method':'get_ticket_project_list',
        'merchant_id': this.SelectedMerchantId?this.SelectedMerchantId:0,
        'confirmed':this.filterData.Iconfirmed,
        'keyword':this.filterData.ticket_project_name,
        'page_number':this.pageNumber,
        'items_per_page':this.itemsPerPage,
      }
      if (this.filterData.QueryStartDate) {
        rptParam.search_start_date = this.filterData.QueryStartDate
      }
      if (this.filterData.QueryEndDate) {
        rptParam.search_end_date = this.filterData.QueryEndDate
      }
      this.isLoading = true
      let vm = this
      apiGetTicketProjectList(rptParam).then(function(resp){
        let data = resp.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          vm.isLoading = false
          return
        }
        if (vm.pageNumber === 1) {
          vm.items = data.data.ticket_project_list
        }
        else {
          vm.items = vm.items.concat(data.data.ticket_project_list)
        }
        if (data.data.total <= vm.items.length) {
          vm.hasMore = false
        }
        vm.isLoading = false
      })
      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   if (vm.pageNumber === 1) {
      //     vm.items = data.data.ticket_project_list
      //   }
      //   else {
      //     vm.items = vm.items.concat(data.data.ticket_project_list)
      //   }
      //   if (data.data.total <= vm.items.length) {
      //     vm.hasMore = false
      //   }
      //   vm.isLoading = false
      // }, this)
    },
    setupNW(row, index) {
      //尚未建立藍新課程者,就顯示一個表單填一填用設定值串藍新api去建立課程
      //已建立藍新課程者,就只能唯讀當前的設定,與提供同步更新按鈕,使用者去藍新後台改好後再抓取一次更新
      this.nw_op_data = this.CpObj(row.item)
      if (!this.nw_op_data.productsno) {
        //主要業務邏輯是從課程的店家和其他設定組出remark2的預設值
        let default_remark2 = this.buildRemark2(this.nw_op_data)
        let expire_date = this.nw_op_data.project_extend_date?this.nw_op_data.project_extend_date:this.nw_op_data.project_end_date
        //api會轉格式,並檢查有效日期格式,所以不用先轉
        //expire_date = expire_date?this.getPartFromDatetimeStr(expire_date,'date_n'):''
        this.newSetData = {
          'product_name':this.nw_op_data.ticket_project_name,
          'remark1':'',
          'remark2':default_remark2,
          'merchant_name':this.nw_op_data.merchant_name,
          'project_end_date':this.nw_op_data.project_end_date,
          'project_extend_date':this.nw_op_data.project_extend_date,
          'sale_price':this.nw_op_data.sale_price,
          'supplier_address':this.nw_op_data.supplier_address,
          'person_in_charge':this.nw_op_data.person_in_charge,
          'expire_date':expire_date
        }
      }
      else {
        //預覽模式時,remark2的\n換行顯示不出來,要replace成<br>
        this.nw_op_data.ez_print_json.remark2 = this.nw_op_data.ez_print_json.remark2.replaceAll('\n','<br>')
      }
      this.popup_ticket_project_id = row.item.ticket_project_id
      this.editingIndex = index
      this.nw_op_class_name = row.item.product_id + row.item.ticket_project_name.substr(0,30) + (row.item.ticket_project_name.length > 30? '...':'')
      this.classModalShow = true
    },
    editPopup: function (row, index) {
      row.item.service_standard_minutes = row.item.service_items.length===1?row.item.service_items[0].service_standard_minutes:''
      row.item.service_assert_minutes = row.item.service_items.length===1?row.item.service_items[0].service_assert_minutes:''
      this.formData = this.CpObj(row.item)
      this.editingIndex = index
      this.modalShow = true
    },
    pickStorePopup(row, index) {
      //reset回列表避免在編輯頁關閉,開另一個課程時帶到錯誤的上一個課程編輯中店家
      this.storeModalMode = 'list'
      this.$refs.selectForm.initDefault()
      this.$refs.selectForm.setDisabled('storeSearchBtnGroup.btnAdd', true)
      this.popup_ticket_project_id = row.item.ticket_project_id
      this.store_pick_class_name = row.item.product_id + row.item.ticket_project_name.substr(0,30) + (row.item.ticket_project_name.length > 30? '...':'')
      this.relStoreList = this.CpObj(row.item.apply_stores)
      this.editingIndex = index
      this.storePickingList = []
      this.storeModalShow = true
      setTimeout(() => {
        //ui不會bind @_@ 反正只是帶預設值,先這樣,能換成merchant_id更好
        this.storePickData.keyword = row.item.merchant_name
        this.searchStoreCandidate()
        setTimeout(() => {
          this.storePickData.keyword = ''
        }, 1000);
      }, 100);
    },
    closeCheck: function (evt) {
      if (this.modalShow) {
        evt.preventDefault()
      }
    },
    closeCheckPick: function (evt) {
      // 沒有要鎖不確定不准關閉...
      if (this.storeModalShow) {
        //evt.preventDefault()
      }
    },
    closeCheckClass(evt) {
      if (this.classModalShow && !this.nw_op_data.productsno) {
        evt.preventDefault()
      }
    },
    setFocus: function () {
      if (this.formData.service_standard_minutes == '') {
        this.$refs.editForm.setFocus('service_standard_minutes')
      }
      else {
        this.$refs.editForm.setFocus('btnCancel')
      }
    },
    modalOK: function (doneCB) {
      if (!this.formData.service_standard_minutes || !this.formData.project_start_date || !this.formData.project_end_date) {
        this.$refs.editForm.triggerAlert("請檢查必填欄位")
        doneCB()
        return
      }
      if (this.formData.project_extend_date && this.formData.project_extend_date < this.formData.project_end_date) {
        this.$refs.editForm.triggerAlert("延長優惠日期不得早於原優惠到期日")
        doneCB()
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'setup_merchant_ticket',
        'ticket_project_id': this.formData.ticket_project_id,
        'service_standard_minutes': this.formData.service_standard_minutes,
        'service_assert_minutes': this.formData.service_assert_minutes,
        'service_quota': 1,
        'usage_limit_per_user': 1,
        'project_start_date': this.formData.project_start_date,
        'project_end_date': this.formData.project_end_date,
        'project_extend_date': this.formData.project_extend_date?this.formData.project_extend_date:'',
        'suggest_price':this.formData.suggest_price?this.formData.suggest_price:''
      }
      //service_assert_minutes只有create時才傳input的值就好,edit時帶舊值
      if (!this.formData.ticket_project_confirmed) {
        Param.service_assert_minutes = this.formData.service_standard_minutes
      }

      let vm = this
      apiSetupMerchantTicket(Param).then(function(resp){
        let data = resp.data
        if (vm.formData.service_items.length > 0) {
          vm.formData.service_items[0].service_standard_minutes = parseInt(vm.formData.service_standard_minutes)
          vm.formData.service_items[0].service_assert_minutes = parseInt(vm.formData.service_standard_minutes)
        }
        else {
          vm.formData.service_items.push({'service_standard_minutes':parseInt(vm.formData.service_standard_minutes),'service_assert_minutes':parseInt(vm.formData.service_standard_minutes)})
        }
        // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
        vm.formData.ticket_project_confirmed = 1
        vm.items[vm.editingIndex] = vm.CpObj(vm.formData)
        vm.items = vm.CpObj(vm.items)
        doneCB()
        vm.modalShow = false
        vm.$bus.fnShowInfo('設定完成')
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$refs.editForm.triggerAlert(data.msg)
            doneCB()
            return
        }
      })
      
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$refs.editForm.triggerAlert(data.msg)
      //       doneCB()
      //       return
      //     }
      //     if (vm.formData.service_items.length > 0) {
      //       vm.formData.service_items[0].service_standard_minutes = parseInt(vm.formData.service_standard_minutes)
      //       vm.formData.service_items[0].service_assert_minutes = parseInt(vm.formData.service_standard_minutes)
      //     }
      //     else {
      //       vm.formData.service_items.push({'service_standard_minutes':parseInt(vm.formData.service_standard_minutes),'service_assert_minutes':parseInt(vm.formData.service_standard_minutes)})
      //     }
      //     // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
      //     vm.formData.ticket_project_confirmed = 1
      //     vm.items[vm.editingIndex] = vm.CpObj(vm.formData)
      //     vm.items = vm.CpObj(vm.items)
      //     doneCB()
      //     vm.modalShow = false
      //     vm.$bus.fnShowInfo('設定完成')
      // }, this)
    },
    modalCancel: function () {
      this.modalShow = false
    },
    forceSync () {
      if (this.isSyncRunning) {
        return
      }
      let rptParam = {
        'module':'admin_manage',
        'method':'forceSyncNow',
      }
      this.isSyncRunning = true

      let vm = this
      apiForceSyncNow(rptParam).then(function(resp){
        let data = resp.data
        vm.isSyncRunning = false
        vm.$bus.fnShowInfo('排程手動呼叫完畢')
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            vm.isSyncRunning = false
            return
        }
      })

      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo(data.msg)
      //       vm.isSyncRunning = false
      //       return
      //     }
      //   vm.isSyncRunning = false
      //   vm.$bus.fnShowInfo('排程手動呼叫完畢')
      // },this)
    }
  },
  created() {
  },
  beforeMount:function() {
    console.log(this.filterData)
    this.filterData.ticket_project_name = this.getQueryVariable(this.mapUrlKey("NI"))?this.getQueryVariable(this.mapUrlKey("NI")):''
    this.SelectedMerchantId = this.getQueryVariable(this.mapUrlKey("SUPPLIER_ID"))?this.getQueryVariable(this.mapUrlKey("SUPPLIER_ID")):''
    console.log(this.filterData)
  },
  mounted() {
    this.isLoading = true
    this.$refs.filterForm.initDefault()
    setTimeout(() => {
      this.$refs.editForm.initDefault()
    }, 100);
    setTimeout(() => {
      this.isLoading = false
      console.log(this.filterData)
      this.filterData.ticket_project_name = this.getQueryVariable(this.mapUrlKey("NI"))?this.getQueryVariable(this.mapUrlKey("NI")):''
      this.SelectedMerchantId = this.getQueryVariable(this.mapUrlKey("SUPPLIER_ID"))?this.getQueryVariable(this.mapUrlKey("SUPPLIER_ID")):''
      console.log(this.filterData)
      this.loadTickets()
    }, 500);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.preview_container{
  position: relative;
}
.preview_general{
  font-size: 12px;
  font-family: cwTeXKai, "Noto Serif TC", "Noto Sans SC", serif;
  font-weight: 300;
  position: absolute;
  top: 0px;
  left: 0px; 
  text-align: left;
  line-height: 1;
}
.total_no{
  top: 50px;
  left: 340px;
}
.order_no{
  top: 50px;
  left: 585px;
}
.barcode1{
  font-weight: 600;
  top: 12px;
  left: 700px;
}
.barcode2{
  font-weight: 600;
  top: 270px;
  left: 175px;
}
.qrcode1{
  font-weight: 600;
  top: 350px;
  left: 800px;
}
.p_name{
  top: 70px;
  left: 340px;
}
.p_remark1{
  top: 90px;
  left: 340px;
}
.p_price{
  top: 113px;
  left: 350px;
}
.p_end_date{
  top: 113px;
  left: 530px;  
}
.preview_content{
  /* z-index: 9999;  */
  top: 150px;
  left: 285px;
  width: 635px;
  height: 117.16px;
}
.s_firm{
  top: 280px;
  left: 370px;
}
.s_name{
  top: 297px;
  left: 530px;
}
.s_address{
  top: 315px;
  left: 370px;
}
.ss_firm{
  top: 345px;
  left: 340px;
}
.ss_invoice{
  top: 365px;
  left: 340px;
}
.ss_name{
  top: 383px;
  left: 340px;
}
.ss_address{
  top: 400px;
  left: 340px;
}
.ss_bank{
  top: 345px;
  left: 690px;
}
.ss_date{
  top: 363px;
  left: 690px;
}
.ss_period{
  top: 381px;
  left: 690px;
}
.ss_num{
  top: 400px;
  left: 690px;
}
.wrapper2 {
  height: 65vh;
  overflow-y: scroll;
  border-style: inset;
}
.wrapper3 {
  height: 150px;
  overflow-y: scroll;
  border-style: inset;
}

</style>
